export const PASSWORD = "Password";
export const SIGNUP = "Sign Up";
export const STAR = "*";
export const EMAIL_ADDRESS = "Email Address";
export const FIRST_NAME = "First Name";
export const LAST_NAME = "Last Name";
export const CONFIRM_PASSWORD = "Confirm Password";
export const CONFIRM_PASSWORD_COMMON = "Password (8+Characters)";
export const ACCESS_CODE = "Enter Access Code";